import { DateService } from "../../services/date.service";
import { RenderColumn } from "../../types/column.types";
import { IMail } from "../../types/mail.types";

export const DateMailColumn: RenderColumn<IMail> = (_, mail) =>
    DateService.getFullDate(mail.created_at);
